import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-nope-confirm-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./nope-confirm-dialog.component.html",
  styleUrl: "./nope-confirm-dialog.component.scss"
})
export class ConfirmNopeDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: { message: string },
    private readonly ref: MatDialogRef<ConfirmNopeDialogComponent>
  ) {}

  /**
   * Close on the next turn so the click/pointer sequence cannot “fall through” the overlay
   * onto the swipe deck (which would trigger Like / match dialog).
   */
  confirm(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
    window.setTimeout(() => this.ref.close(true), 0);
  }

  cancel(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
    window.setTimeout(() => this.ref.close(false), 0);
  }
}

